module.exports = __webpack_public_path__ + "static/media/bird_fly_page3.a6fc9f80.png";